import React from 'react';
import './faqs.scss';
import Accordion from 'react-bootstrap/Accordion';

const Faqs = () => {
  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How do I start using TOMI?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Download the app and create an account - no email or phone needed. Visit our [Support Center] to learn more or check out the [Getting Started Guide]."
        }
      },
      {
        "@type": "Question",
        "name": "What makes TOMI different from other chat apps?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "TOMI combines messaging with crypto payments, multiple profiles, and complete privacy. All without requiring any personal information and with full control over your data."
        }
      },
      {
        "@type": "Question",
        "name": "Is my data secure and private?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, everything is end-to-end encrypted and stored on decentralized storage that only you control. Learn more in our Storage page. [add link]"
        }
      }
    ]
  };

  return (
    <section className='faqsmainprnt'>
      <div className="postionfaqs">
        <img className='img-fluid' src="/assets/faqpositionimg.png" alt="FAQs Background" />
      </div>
      <div className="custom-container">
        <div className="faqschldmain">
          <h2>FAQ</h2>
          <div className="faqscustumdesigine">
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <h3 className="btninner">How do I start using TOMI?</h3>
                </Accordion.Header>
                <Accordion.Body>
                  <p className="bodymain">
                    Download the app and create an account - no email or phone needed. Visit our [Support Center] to learn more or check out the [Getting Started Guide].
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <h3 className="btninner">What makes TOMI different from other chat apps?</h3>
                </Accordion.Header>
                <Accordion.Body>
                  <p className="bodymain">
                    TOMI combines messaging with crypto payments, multiple profiles, and complete privacy. All without requiring any personal information and with full control over your data.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <h3 className="btninner">Is my data secure and private?</h3>
                </Accordion.Header>
                <Accordion.Body>
                  <p className="bodymain">
                    Yes, everything is end-to-end encrypted and stored on decentralized storage that only you control. Learn more in our Storage page. [add link]
                  </p>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
      {/* Adding FAQ Schema for SEO */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqData) }} />
    </section>
  );
};

export default Faqs;